import { buildSearchMap } from '@/components/FileBrowser/utils';
import type { Folder } from '@types';

// eslint-disable-next-line import/prefer-default-export
export const getMostRecentFiles = (files: Folder, limit: number) =>
  buildSearchMap(files)
    .filter((file) => file.type === 'file')
    .sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1))
    .slice(0, limit);
